import * as React from 'react';
import addDays from 'date-fns/addDays';
import setDay from 'date-fns/setDay';
import { Order } from '../BookingsCalendarTypes';
import { getOrderProperties } from './getOrderProperties';

type useBookingDateProps = {
    selectedOrder?: Order;
    isAdvancedMode?: boolean;
    bookingDate: Date;
    handleChangeBookingDate: (newBookingDate: Date) => void;
    selectedRegion: number;
    handleChangeRegionFilter: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    selectedProperties: number[];
    handleChangeSelectedProperties: (event: number[]) => void;
    executionTime: number;
    handleChangeExecutionTime: (newExecutionTime: number) => void;
};

const useBookingDetails = (selectedOrder, isAdvancedMode): useBookingDateProps => {
    const today = new Date();
    const tomorrow = addDays(today, 1);
    const nextMonday = addDays(today, 3);
    const defaultBookingDate = today.getDay() === 5 ? nextMonday : tomorrow;

    const [bookingDate, setBookingDate] = React.useState<Date>(defaultBookingDate);
    const [selectedRegion, setSelectedRegion] = React.useState<number>(
        Number(selectedOrder.orderAddress.regionId)
    );

    const properties = getOrderProperties(selectedOrder.productProperties);

    const [selectedProperties, setSelectedProperties] = React.useState(
        properties.length > 0 ? properties : []
    );
    const [executionTime, setExecutionTime] = React.useState<number | null>(null);

    const handleChangeBookingDate = (newBookingDate: Date) => {
        setBookingDate(newBookingDate);
    };

    const handleChangeRegionFilter = React.useCallback(
        (event: React.ChangeEvent<HTMLSelectElement>) => {
            setSelectedRegion(Number(event.target.value));
        },
        []
    );

    const handleChangeSelectedProperties = React.useCallback((event: number[]) => {
        setSelectedProperties(event);
    }, []);

    const handleChangeExecutionTime = React.useCallback((newExecutionTime: number) => {
        setExecutionTime(newExecutionTime);
    }, []);

    React.useEffect(() => {
        setBookingDate(defaultBookingDate);
        setSelectedRegion(Number(selectedOrder.orderAddress.regionId));
        setSelectedProperties(properties.length > 0 ? properties : []);
        setExecutionTime(null);
    }, [selectedOrder]);

    React.useEffect(() => {
        if (!isAdvancedMode) {
            setExecutionTime(null);
        }
    }, [isAdvancedMode]);

    return {
        bookingDate,
        handleChangeBookingDate,
        selectedRegion,
        handleChangeRegionFilter,
        selectedProperties,
        handleChangeSelectedProperties,
        executionTime,
        handleChangeExecutionTime
    };
};

export default useBookingDetails;
